import PerformRequest from '../../axios';

export const ChatApi = {
  getUsers: async () => {
    return await PerformRequest('chat', 'GET');
  },

  getUserChatDetails: async (userId, pageNumber, search = '') => {
    const query = search ? `?search=${encodeURIComponent(search)}` : '';
    return await PerformRequest(`chat/${userId}/${pageNumber}${query}`, 'GET');
  },

  deleteUserChat: async (userId) => {
    return await PerformRequest(`chat/user/${userId}`, 'DELETE');
  },

  searchUser: async (searchQuery) => {
    return await PerformRequest(`search/user?search=${searchQuery}`, 'GET');
  },

  getGroups: async () => {
    return await PerformRequest('chat/group', 'GET');
  },

  getGroupById: async (id, pageNumber, search = '') => {
    const query = search ? `?search=${encodeURIComponent(search)}` : '';
    return await PerformRequest(`chat/group/${id}/${pageNumber}${query}`, 'GET');
  },

  createGroup: async (data) => {
    return await PerformRequest('chat/group', 'POST', data);
  },

  updateGroupDetails: async (id, data) => {
    return await PerformRequest(`chat/group/${id}`, 'PATCH', data);
  },

  addUserToGroup: async (groupId, userIds) => {
    return await PerformRequest(`chat/group/user/${groupId}`, 'PATCH', { action: 'ADD', userIds });
  },

  removeUserFromGroup: async (groupId, userIds) => {
    return await PerformRequest(`chat/group/user/${groupId}`, 'PATCH', {
      action: 'REMOVE',
      userIds,
    });
  },

  handleGroupDeletion: async (id) => {
    return await PerformRequest(`chat/group/${id}${'?deleteForEveryone=true'}`, 'DELETE');
  },

  handleGroupChatDeletion: async (id) => {
    return await PerformRequest(`chat/group/${id}`, 'DELETE');
  },

  leaveGroup: async (id) => {
    return await PerformRequest(`/chat/group/leave/${id}`, 'DELETE');
  },

  makeAdmin: async (groupId, userId) => {
    return await PerformRequest(`chat/group/role/${groupId}`, 'PATCH', { userId, role: 'ADMIN' });
  },

  makeUser: async (groupId, userId) => {
    return await PerformRequest(`chat/group/role/${groupId}`, 'PATCH', { userId, role: 'USER' });
  },
  editMessage: async (messageId, message) => {
    return await PerformRequest(`chat/message/${messageId}`, 'PATCH', { message });
  },
  getMessageDetailsById: async (messageId) => {
    return await PerformRequest(`chat/message/${messageId}`, 'GET');
  },
  handleDeleteChatMessage: async (messageId) => {
    return await PerformRequest(`chat/message/${messageId}`, 'DELETE');
  },

  addEmojiReaction: async (messageId, emoji) => {
    return await PerformRequest(`chat/message/react/${messageId}`, 'POST', { content: emoji });
  },

  removeEmojiReaction: async (messageId) => {
    return await PerformRequest(`chat/message/react/${messageId}`, 'POST', {
      action: 'REMOVE',
      content: '',
    });
  },

  syncMessages: async (since) => {
    return await PerformRequest(`chat/sync?since=${encodeURIComponent(since)}`, 'GET');
  },

  sendMessageHttp: async (data) => {
    return await PerformRequest('chat/message', 'POST', data);
  },

  pinMessage: async (messageId, chatId) => {
    return await PerformRequest(`chat/message/pin/${messageId}`, 'POST', { chatId });
  },

  unpinMessage: async (messageId, chatId) => {
    return await PerformRequest(`chat/message/unpin/${messageId}`, 'POST', { chatId });
  },

  getPinnedMessages: async (chatId) => {
    return await PerformRequest(`chat/pinned/${chatId}`, 'GET');
  },

  forwardMessage: async (messageId, targetChatId) => {
    return await PerformRequest('chat/message/forward', 'POST', { messageId, targetChatId });
  },

  getUnreadCount: async () => {
    return await PerformRequest('chat/unread-count', 'GET');
  },
};
